import {
  getUserInfo,
  uploadStampImage,
  checkValidateBasicInfo,
  updateBasicInfo,
  getUserPermission,
  editDestinationInfo,
  getDestinationInfo,
  checkValidateEditDestinationInfo,
  sendDestinationVerifyMail,
  verifyDestinationEmail,
  verifyBasicInfoEmail,
  getFile,
  getFileStamp
} from '@/apis/user';
import { DEFAULT_DATE_FORMAT } from '@/constants/common';
import dayjs from '@/plugins/dayjs';
import lodash from 'lodash';
import { USERS } from '../mutation-types';

export const state = {
  user: {},
  stampImage: '',
  formData: {},
  validateBasicInfo: '',
  basicInfo: {},
  permissions: [],
  destinationInfo: {},
  destinationInfoEdit: {},
  serverErrors: {},
  index: 0,
  estateFavorites: []
};

export const getters = {
  userInfo: state => {
    state.user.license_start_date = dayjs(state.user.license_start_date, DEFAULT_DATE_FORMAT);
    state.user.license_expire_date = dayjs(state.user.license_expire_date, DEFAULT_DATE_FORMAT);

    return state.user;
  },

  formData: state => {
    // eslint-disable-next-line max-len
    state.formData.license_start_date = dayjs(state.formData.license_start_date, DEFAULT_DATE_FORMAT);
    // eslint-disable-next-line max-len
    state.formData.license_expire_date = dayjs(state.formData.license_expire_date, DEFAULT_DATE_FORMAT);

    return state.formData;
  },

  basicInfo: state => {
    // eslint-disable-next-line max-len
    state.basicInfo.license_start_date = dayjs(state.basicInfo.license_start_date, DEFAULT_DATE_FORMAT);
    // eslint-disable-next-line max-len
    state.basicInfo.license_expire_date = dayjs(state.basicInfo.license_expire_date, DEFAULT_DATE_FORMAT);

    return state.basicInfo;
  },
  userPermission: state => state.permissions,

  destinationInfo: (state) => state.destinationInfo,
  destinationInfoEdit: (state) => state.destinationInfoEdit,
  serverErrors: (state) => state.serverErrors,
  index: (state) => state.index,
  estateFavorites: (state) => state.estateFavorites,
};

export const mutations = {
  [USERS.GET_USER_INFO](state, data) {
    if (!data.error) {
      state.formData = lodash.cloneDeep(data);
      state.basicInfo = lodash.cloneDeep(data);
      state.user = data;
      state.formData.email_confirm = data.mail_address;
      state.estateFavorites = data.estate_favorite_of_company.map((v) => v?.id);
    }
  },
  [USERS.UPLOAD_STAMP_IMAGE](state, data) {
    if (!data.error) {
      state.stampImage = data;
    }
  },
  [USERS.CHECK_VALIDATE_BASIC_INFO](state, data) {
    state.validateBasicInfo = data;
  },
  // [USERS.UPDATE_BASIC_INFO](state, data) {
  //   state.user = lodash.cloneDeep(data);
  //   state.basicInfo = lodash.cloneDeep(data);
  // },
  [USERS.GET_USER_PERMISSION](state, data) {
    state.permissions = data;
  },
  clearBasicInfo(state) {
    state.basicInfo = {};
  },
  [USERS.GET_DESTINATION_INFO](state, data) {
    if (!data.error) {
      state.destinationInfo = lodash.cloneDeep(data);
      state.destinationInfo.mail_address_confirmation = lodash.cloneDeep(data.mail_address);
      state.destinationInfoEdit = lodash.cloneDeep(data);
      state.destinationInfoEdit.mail_address_confirmation = lodash.cloneDeep(data.mail_address);
    }
  },
  [USERS.CREATE_SERVER_ERROR](state, errors) {
    const firstError = {};
    Object.keys(errors).forEach((value) => {
      [firstError[value]] = errors[value];
    });
    state.serverErrors = firstError;
  },
  changeIndex(state, index) {
    state.index = index;
  },
  updateFavoriteEstate(state, biddingId) {
    const indexId = state.estateFavorites.indexOf(biddingId);
    if (indexId > -1) {
      state.estateFavorites.splice(indexId, 1);
    } else {
      state.estateFavorites.push(biddingId);
    }
  },
};

export const actions = {
  async getUserInfo({ commit }) {
    const res = await getUserInfo();
    commit(USERS.GET_USER_INFO, res);

    return res;
  },

  async uploadStampImage({ commit }, payload) {
    const res = await uploadStampImage(payload);
    if (res.error) {
      return res;
    }
    commit(USERS.UPLOAD_STAMP_IMAGE, res);

    return false;
  },

  async checkValidateBasicInfo({ commit }, payload) {
    const res = await checkValidateBasicInfo(payload);
    if (res.error) {
      return res;
    }
    commit(USERS.CHECK_VALIDATE_BASIC_INFO, res);

    return false;
  },

  async updateBasicInfo({ commit }, payload) {
    const res = await updateBasicInfo(payload);
    if (res.error) {
      return res;
    }

    return false;
  },

  async getPermission({ commit }) {
    const res = await getUserPermission();
    commit(USERS.GET_USER_PERMISSION, res);

    return res;
  },
  async getDestinationInfo({ commit }) {
    const res = await getDestinationInfo();
    commit(USERS.GET_DESTINATION_INFO, res);
    return res;
  },
  async checkValidateEditDestinationInfo({ commit }, payload) {
    const res = await checkValidateEditDestinationInfo(payload);
    if (res.error) {
      commit(USERS.CREATE_SERVER_ERROR, res?.error?.response?.data?.errors);

      return {
        error: true,
        messages: res?.error?.response?.data?.errors,
      };
    }

    return { error: false };
  },
  async editDestinationInfo({ commit }, data) {
    const res = await editDestinationInfo(data.destinationId, data.payload);
    if (res.error) {
      return {
        success: false,
        status: res.error.response.status
      };
    }

    return {
      success: true
    };
  },
  async sendDestinationVerifyMail({ commit }, destinationInfoId) {
    const res = await sendDestinationVerifyMail(destinationInfoId);
    return !res.error;
  },
  async verifyDestinationEmail({ commit }, token) {
    const res = await verifyDestinationEmail(token);
    return !res.error;
  },
  async verifyBasicInfoEmail({ commit }, token) {
    const res = await verifyBasicInfoEmail(token);
    return !res.error;
  },
  getFileStamp({ commit }, data) {
    return getFileStamp(data.id, data.type, data.sorting);
  },
  getFile({ commit }, data) {
    console.log(data);
    return getFile(data.id, data.type, data.sorting, data.file);
  }
};
